// extracted by mini-css-extract-plugin
module.exports = {"d1nias15":"d1nias15","desktop-header":"desktop-header","have-shadow":"have-shadow"};